<div class="component-container flex flex-col justify-center items-center">
  <div class="content flex flex-row justify-center items-center">

    <div class="display-section flex flex-col justify-center items-center">
      <div *ngFor="let eachQuestion of obQuestions"
           [ngSwitch]="eachQuestion.answerType"
           class="row flex flex-row flex-wrap
           justify-between items-center">
        <ng-container *ngSwitchCase="1">
          <div class="sub-row flex flex-col md:flex-row justify-between items-center gap-[1rem]">
            <div class="label w-full md:w-6/12 md:mb-[2rem] flex items-center">
              <div>
                <span> {{ eachQuestion.question }} </span>
                <app-icon *ngIf="eachQuestion.tooltipText"
                          [matTooltip]="eachQuestion.tooltipText"
                          class="tooltip-icon"
                          matTooltipClass="custom-tooltip"
                          matTooltipPosition="below"
                          svgIcon="info"></app-icon>
              </div>

            </div>
            <app-dropdown (checkForErrors)="checkForErrors($event)"
                          [controlName]="''+eachQuestion.questionKey"
                          [error]="errorMessages[''+eachQuestion.questionKey]"
                          [options]="eachQuestion.options"
                          [parentFormGroup]="form"
                          class="input w-full md:w-6/12"
                          placeholder="Select one"
                          type="small"/>
          </div>
          <div *ngIf="otherPronounSelected && eachQuestion.questionKey === 'whatDoYouLikeToBeCalled'"
               class="sub-row flex flex-col md:flex-row justify-between items-center gap-[1rem]">
            <div class="label w-full md:w-6/12 md:mb-[2rem]">
              Other
            </div>
            <app-text-input (checkForErrors)="checkForErrors($event)"
                            [controlName]="''+eachQuestion.questionKey+'_Other'"
                            [error]="errorMessages[''+eachQuestion.questionKey+'_Other']"
                            [maxLength]="validation.onboarding.otherPronoun.length.max"
                            [minLength]="validation.onboarding.otherPronoun.length.min"
                            [parentFormGroup]="form"
                            class="input w-full md:w-6/12 mb-[0.5rem]"
                            placeholder="Enter your text here"
                            showCharCount="true"
                            type="small"></app-text-input>
          </div>
          <div *ngIf="otherPreferredLanguageSelected && eachQuestion.questionKey === 'preferredLaguage'"
               class="sub-row flex flex-col md:flex-row justify-between items-center gap-[1rem]">
            <div class="label w-full md:w-6/12 md:mb-[2rem]">
              Other preferred language
            </div>
            <app-text-input (checkForErrors)="checkForErrors($event)"
                            [controlName]="''+eachQuestion.questionKey+'_Other'"
                            [error]="errorMessages[''+eachQuestion.questionKey+'_Other']"
                            [maxLength]="validation.onboarding.otherLang.length.max"
                            [minLength]="validation.onboarding.otherLang.length.min"
                            [parentFormGroup]="form"
                            class="input w-full md:w-6/12 mb-[0.5rem]"
                            placeholder="Enter your text here"
                            showCharCount="true"
                            type="small"></app-text-input>
          </div>
          <div *ngIf="otherMedicationSelected && eachQuestion.questionKey ===
          'medication'"
               class="sub-row flex flex-col md:flex-row justify-between items-center gap-[1rem]">
            <div class="label w-full md:w-6/12 md:mb-[2rem]">
              List each medication and what it's used for.
            </div>
            <app-text-area-input
              (checkForErrors)="checkForErrors($event)"
              [controlName]="''+eachQuestion.questionKey+'_Other'"
              [error]="errorMessages[''+eachQuestion.questionKey+'_Other']"
              [parentFormGroup]="form"
              class="input w-full md:w-6/12 mb-[0.5rem]"
              placeholder="Enter your text here"
              type="small"
            ></app-text-area-input>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="2">
          <div class="sub-row flex flex-col md:flex-row justify-between items-center gap-[1rem]">
            <div class="label w-full md:w-6/12 md:mb-[2rem]">
              <div><span> {{ eachQuestion.question }} </span>
                <app-icon *ngIf="eachQuestion.tooltipText"
                          [matTooltip]="eachQuestion.tooltipText"
                          class="tooltip-icon"
                          matTooltipClass="custom-tooltip"
                          matTooltipPosition="below"
                          svgIcon="info"></app-icon>
              </div>
            </div>
            <app-dropdown (checkForErrors)="checkForErrors($event)"
                          [controlName]="''+eachQuestion.questionKey"
                          [enableMultiple]="true"
                          [error]="errorMessages[''+eachQuestion.questionKey]"
                          [options]="eachQuestion.options"
                          [parentFormGroup]="form"
                          class="input w-full md:w-6/12"
                          placeholder="Select one"
                          type="small"/>
          </div>
          <div *ngIf="otherSelfDescribeSelected && eachQuestion.questionKey === 'selfDescribe'"
               class="sub-row flex flex-col md:flex-row justify-between items-center gap-[1rem]">
            <div class="label w-full md:w-6/12 md:mb-[2rem]">
              Other race
            </div>
            <app-text-input (checkForErrors)="checkForErrors($event)"
                                 [controlName]="''+eachQuestion.questionKey+'_Other'"
                                 [error]="errorMessages[''+eachQuestion.questionKey+'_Other']"
                                 [maxLength]="validation.onboarding.other.length.max"
                                 [parentFormGroup]="form"
                                 class="input w-full md:w-6/12 mb-[0.5rem]"
                                 placeholder="Enter your text here"
                                 showCharCount="true"
                                 type="small"></app-text-input>
          </div>
          <div *ngIf="otherMedicalInsuranceSelected && eachQuestion.questionKey === 'medicalInsurance'"
               class="sub-row flex flex-col md:flex-row justify-between items-center gap-[1rem]">
            <div class="label w-full md:w-6/12 md:mb-[2rem]">
              Other health insurance or health coverage plan:
            </div>
            <app-text-input (checkForErrors)="checkForErrors($event)"
                            [controlName]="''+eachQuestion.questionKey+'_Other'"
                            [error]="errorMessages[''+eachQuestion.questionKey+'_Other']"
                            [maxLength]="validation.onboarding.otherInsurance.length.max"
                            [minLength]="validation.onboarding.otherInsurance.length.min"
                            [parentFormGroup]="form"
                            class="input w-full md:w-6/12 mb-[0.5rem]"
                            placeholder="Enter your text here"
                            showCharCount="true"
                            type="small"></app-text-input>
          </div>
          <div *ngIf="otherUnderGraduateDegreesSelected && eachQuestion.questionKey === 'undergraduateDegrees'"
               class="sub-row flex flex-col md:flex-row justify-between items-center gap-[1rem]">
            <div class="label w-full md:w-6/12 md:mb-[2rem]">
              Other undergraduate degree (abbreviation)
            </div>
            <app-text-area-input (checkForErrors)="checkForErrors($event)"
                                 [controlName]="''+eachQuestion.questionKey+'_Other'"
                                 [error]="errorMessages[''+eachQuestion.questionKey+'_Other']"
                                 [maxLength]="validation.onboarding.other.length.max"
                                 [parentFormGroup]="form"
                                 class="input w-full md:w-6/12 mb-[0.5rem]"
                                 placeholder="Enter your text here"
                                 showCharCount="true"
                                 type="small"></app-text-area-input>
          </div>
          <div *ngIf="otherMastersDegreesSelected && eachQuestion.questionKey === 'masterDegrees'"
               class="sub-row flex flex-col md:flex-row justify-between items-center gap-[1rem]">
            <div class="label w-full md:w-6/12 md:mb-[2rem]">
              Other Master's degree (abbreviation)
            </div>
            <app-text-area-input (checkForErrors)="checkForErrors($event)"
                                 [controlName]="''+eachQuestion.questionKey+'_Other'"
                                 [error]="errorMessages[''+eachQuestion.questionKey+'_Other']"
                                 [maxLength]="validation.onboarding.other.length.max"
                                 [parentFormGroup]="form"
                                 class="input w-full md:w-6/12 mb-[0.5rem]"
                                 placeholder="Enter your text here"
                                 showCharCount="true"
                                 type="small"></app-text-area-input>
          </div>
          <div *ngIf="otherDoctorateDegreesSelected && eachQuestion.questionKey === 'doctorateDegrees'"
               class="sub-row flex flex-col md:flex-row justify-between items-center gap-[1rem]">
            <div class="label w-full md:w-6/12 md:mb-[2rem]">
              Other Doctorate degree (abbreviation)
            </div>
            <app-text-area-input (checkForErrors)="checkForErrors($event)"
                                 [controlName]="''+eachQuestion.questionKey+'_Other'"
                                 [error]="errorMessages[''+eachQuestion.questionKey+'_Other']"
                                 [maxLength]="validation.onboarding.other.length.max"
                                 [parentFormGroup]="form"
                                 class="input w-full md:w-6/12 mb-[0.5rem]"
                                 placeholder="Enter your text here"
                                 showCharCount="true"
                                 type="small"></app-text-area-input>
          </div>
          <div *ngIf="otherProfessionalLicensesSelected && eachQuestion.questionKey === 'professionalLicenses'"
               class="sub-row flex flex-col md:flex-row justify-between items-center gap-[1rem]">
            <div class="label w-full md:w-6/12 md:mb-[2rem]">
              Other professional license and/or certification (abbreviation)
            </div>
            <app-text-area-input (checkForErrors)="checkForErrors($event)"
                                 [controlName]="''+eachQuestion.questionKey+'_Other'"
                                 [error]="errorMessages[''+eachQuestion.questionKey+'_Other']"
                                 [maxLength]="validation.onboarding.other.length.max"
                                 [parentFormGroup]="form"
                                 class="input w-full md:w-6/12 mb-[0.5rem]"
                                 placeholder="Enter your text here"
                                 showCharCount="true"
                                 type="small"></app-text-area-input>
          </div>
          <div *ngIf="otherOrganizationTypeSelected && eachQuestion.questionKey === 'organizationType'"
               class="sub-row flex flex-col md:flex-row justify-between items-center gap-[1rem]">
            <div class="label w-full md:w-6/12 md:mb-[2rem]">
              Describe your organization
            </div>
            <app-text-area-input (checkForErrors)="checkForErrors($event)"
                                 [controlName]="''+eachQuestion.questionKey+'_Other'"
                                 [error]="errorMessages[''+eachQuestion.questionKey+'_Other']"
                                 [maxLength]="validation.onboarding.other.length.max"
                                 [parentFormGroup]="form"
                                 class="input w-full md:w-6/12 mb-[0.5rem]"
                                 placeholder="Enter your text here"
                                 showCharCount="true"
                                 type="small"></app-text-area-input>
          </div>
          <div *ngIf="otherMedicalProblemsSelected &&
          eachQuestion.questionKey === 'medicalProblems'"
               class="sub-row flex flex-col md:flex-row justify-between items-center gap-[1rem]">
            <div class="label w-full md:w-6/12 md:mb-[2rem]">
              Other medical problem
            </div>
            <app-text-area-input (checkForErrors)="checkForErrors($event)"
                                 [controlName]="''+eachQuestion.questionKey+'_Other'"
                                 [error]="errorMessages[''+eachQuestion.questionKey+'_Other']"
                                 [parentFormGroup]="form"
                                 class="input w-full md:w-6/12 mb-[0.5rem]"
                                 placeholder="Enter your text here"
                                 type="small"></app-text-area-input>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="3">
          <div class="sub-row flex flex-col md:flex-row justify-between items-center gap-[1rem]">
            <div class="label w-full md:w-6/12 md:mb-[2rem]">
              <div>
                <span> {{ eachQuestion.question }} </span>
                <app-icon *ngIf="eachQuestion.tooltipText"
                          [matTooltip]="eachQuestion.tooltipText"
                          class="tooltip-icon"
                          matTooltipClass="custom-tooltip"
                          matTooltipPosition="below"
                          svgIcon="info"></app-icon>
              </div>
            </div>
            <app-number-input
              (checkForErrors)="checkForErrors($event)"
              [controlName]="''+eachQuestion.questionKey"
              [error]="errorMessages[''+eachQuestion.questionKey]"
              [parentFormGroup]="form"
              class="input w-full md:w-6/12"
              placeholder="Type here"
              type="small">

            </app-number-input>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="4">
          <div class="sub-row flex flex-col md:flex-row justify-between items-center gap-[1rem]">
            <div class="label w-full md:w-6/12 md:mb-[2rem]">
              <div>
                <span> {{ eachQuestion.question }} </span>
                <app-icon *ngIf="eachQuestion.tooltipText"
                          [matTooltip]="eachQuestion.tooltipText"
                          class="tooltip-icon"
                          matTooltipClass="custom-tooltip"
                          matTooltipPosition="below"
                          svgIcon="info"></app-icon>
              </div>
            </div>
            <app-text-input (checkForErrors)="checkForErrors($event)"
                            [controlName]="''+eachQuestion.questionKey"
                            [error]="errorMessages[''+eachQuestion.questionKey]"
                            [parentFormGroup]="form"
                            class="input w-full md:w-6/12"
                            placeholder="Type here"
                            type="small"></app-text-input>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="action-btn flex w-full justify-end space-x-[1rem]">
    <app-primary-button (handleClick)="save()"
                        [isDisabled]="!form.dirty"
                        class="save-btn w-[8rem]"
                        type="small">
      Save
    </app-primary-button>
    <app-primary-button (handleClick)="close()"
                        class="close-btn w-[8rem]"
                        type="small">
      Close
    </app-primary-button>
  </div>
</div>
